import { createContext, useState } from "react";

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
    const [darkTheme, setDarkThem] = useState(false);
    const toggleTheme = () => {
        setDarkThem(!darkTheme);
    }
    return (
        <ThemeContext.Provider value={{ darkTheme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    )

}

export default ThemeProvider